
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    loginPage: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--brand-bg, #f4eeee)',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        padding: '0px',
    },
    container: {
        width: '100%',
        maxWidth: '440px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 'auto',
        marginTop: 'auto',
        [theme.breakpoints.down('sm')]: {
            width: '75%',
        },
    },
    welcomeText: {
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    logo: {
        height: '90px',
        marginBottom: '35px',
        objectFit: 'contain',
    },
    googleButton: {
        width: '100%',
        height: '50px',
        backgroundColor: 'var(--brand-surface, #ffffff) !important',
        color: 'var(--brand-text, #1a1a1a) !important',
        border: '1.5px solid var(--brand-border, #dedede) !important',
        borderRadius: '12px !important',
        fontSize: '16px !important',
        fontWeight: '600 !important',
        textTransform: 'none !important',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        gap: '15px',
        marginBottom: '20px !important',
        boxShadow: 'none !important',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif !important",
        '&:hover': {
            backgroundColor: 'var(--brand-surface, #fafafa) !important',
            borderColor: 'var(--brand-border, #ccc) !important',
        },
    },
    dividerContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        marginBottom: '30px',
    },
    dividerLine: {
        flex: 1,
        height: '1.5px',
        backgroundColor: 'var(--brand-border, #d1d0d0)',
    },
    dividerText: {
        color: 'var(--brand-text-muted, #999)',
        fontSize: '15px',
        fontWeight: '700',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    },
    form: {
        width: '100%',
        textAlign: 'left',
    },
    label: {
        fontSize: '18px',
        fontWeight: 'bold !important',
        color: 'var(--brand-text, #333)',
        marginBottom: '3px !important',
        display: 'block',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    },
    input: {
        width: '100%',
        height: '48px',
        padding: '0 20px',
        border: '2px solid var(--brand-border, #e5e5e5)',
        borderRadius: '12px',
        fontSize: '15px',
        color: 'var(--brand-text, #333)',
        backgroundColor: 'var(--brand-surface, #fff)',
        outline: 'none',
        marginBottom: '12px !important',
        boxSizing: 'border-box',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        transition: 'border-color 0.2s',
        '&::placeholder': {
            color: 'var(--brand-text-muted, #bfbfbf)',
        },
        '&:focus': {
            borderColor: '#FFAB46',
        },
        '&:-webkit-autofill': {
            '-webkit-box-shadow': '0 0 0 100px var(--brand-surface, #fff) inset !important',
            '-webkit-text-fill-color': 'var(--brand-text, #333) !important',
        },
    },
    continueButton: {
        width: '100%',
        height: '50px',
        background: 'linear-gradient(90deg, #F14A24, #FF7043) !important',
        color: '#ffffff !important',
        borderRadius: '7px !important',
        fontSize: '16px !important',
        fontWeight: '800 !important',
        textTransform: 'none !important',
        marginBottom: '10px !important',
        marginTop: '17px !important',
        boxShadow: 'none !important',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif !important",
        transition: 'background 0.3s ease',
        '&:hover': {
            background: 'linear-gradient(90deg, #D13A14, #F4511E) !important',
        },
    },
    continueButtonActive: {
        background: 'linear-gradient(90deg, #F14A24, #FF7043) !important',
        '&:hover': {
            background: 'linear-gradient(90deg, #D13A14, #F4511E) !important',
        },
    },
    signupText: {
        fontSize: '18px',
        color: 'var(--brand-text-muted, #666)',
        marginBottom: '80px',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    },
    signupLink: {
        color: 'var(--brand-text, #000)',
        fontWeight: '800',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    footerContainer: {
        marginTop: 'auto',
        paddingBottom: '10px',
    },
    footerText: {
        fontSize: '12px',
        color: 'var(--brand-text-muted, #777)',
        fontFamily: "'Surt', sans-serif",
    },
    footerLink: {
        textDecoration: 'underline',
        cursor: 'pointer',
        color: 'var(--brand-text-muted, #777)',
    },
}));

export default useStyles;
